const CONST_CAMPAIGN_NAME_GBG = 'g�teborg'
const CONST_CAMPAIGN_NAME_STHLM = 'stockholm'
const CONST_CAMPAIGN_NAME_TRANSIT = 'transit'
const CONST_CAMPAIGN_NAME_MALMO = 'malm�'
const CONST_CAMPAIGN_NAME_SKANE = 'sk�ne'
const CONST_CAMPAIGN_NAME_NATIONAL = 'national'
const CONST_CAMPAIGN_NAME_BIGCITY = 'big city'

export default class IDSCalculator {

    static caluclateIDS_ReachAndFrequencyBasedOnCampaignName(idsRegionValues, periodEnd, idsUseNationalStart, campaignName) {

        let idsReachValue = 0, idsAverageFrequencyValue = 0;

        if (idsRegionValues !== null) {
            if (moment(periodEnd).format('YYYY-MM-DD') >= moment(idsUseNationalStart).format('YYYY-MM-DD')) {
                idsReachValue = idsRegionValues.national["reach"];
                idsAverageFrequencyValue = idsRegionValues.national["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_GBG)) {
                idsReachValue = idsRegionValues.goteborg["reach"];
                idsAverageFrequencyValue = idsRegionValues.goteborg["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_STHLM)) {
                idsReachValue = idsRegionValues.stockholm["reach"];
                idsAverageFrequencyValue = idsRegionValues.stockholm["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_TRANSIT)) {
                idsReachValue = idsRegionValues.stockholm["reach"];
                idsAverageFrequencyValue = idsRegionValues.stockholm["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_MALMO)) {
                idsReachValue = idsRegionValues.malmo["reach"];
                idsAverageFrequencyValue = idsRegionValues.malmo["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_SKANE)) {
                idsReachValue = idsRegionValues.malmo["reach"];
                idsAverageFrequencyValue = idsRegionValues.malmo["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_NATIONAL)) {
                idsReachValue = idsRegionValues.national["reach"];
                idsAverageFrequencyValue = idsRegionValues.national["averageFrequency"];
            }
            else if (campaignName.toLowerCase().includes(CONST_CAMPAIGN_NAME_BIGCITY)) {
                idsReachValue = idsRegionValues.stockholm["reach"] + idsRegionValues.goteborg["reach"] + idsRegionValues.malmo["reach"];
                idsAverageFrequencyValue = idsRegionValues.stockholm["averageFrequency"] + idsRegionValues.goteborg["averageFrequency"] + idsRegionValues.malmo["averageFrequency"];
            }
        }

        return { Reach: idsReachValue, Frequency: idsAverageFrequencyValue };
    }

    static caluclateIDS_ReachAndFrequencyNationalValues(idsRegionValues, periodEnd, idsUseNationalStart) {

        let idsReachValue = 0, idsAverageFrequencyValue = 0;

        if (idsRegionValues !== null) {
            if (moment(periodEnd).format('YYYY-MM-DD') >= moment(idsUseNationalStart).format('YYYY-MM-DD')) {
                idsReachValue = idsRegionValues.national["reach"];
                idsAverageFrequencyValue = idsRegionValues.national["averageFrequency"];
            }
        }

        return { Reach: idsReachValue, Frequency: idsAverageFrequencyValue };
    }

}
